// export const baseUrl = "https://api.mispotreros.com/api/";
export const baseUrl =
  "https://us-central1-control-ganadero-ee861.cloudfunctions.net/api/web/";
// export const baseUrl = "http://localhost:4000/api/";

// export const baseUrl = "https://efacture.app/api/";
